module.exports = __webpack_public_path__ + "static/img/son13_active.f0f6a14e.jpg";